import { ComponentPropsWithoutRef, forwardRef, ReactNode } from 'react';
import { cn } from '@/shadcn-ui/utils';
import SavingsBadgeIcon from '@/icons/savings-badge-icon';
import Spacer from '@/common/components/spacer';

export interface SalesPitchTextContainerProps extends ComponentPropsWithoutRef<'div'> {
  isOnPDP: boolean;
  showSavings: boolean;
  showSavingsCalculatorV2: boolean;
  children: ReactNode;
  className?: string;
}

const SalesPitchTextContainer = forwardRef<HTMLDivElement, SalesPitchTextContainerProps>(
  (
    {
      isOnPDP,
      showSavings,
      showSavingsCalculatorV2,
      children,
      className,
      ...props
    }: SalesPitchTextContainerProps,
    ref
  ) => {
    return (
      <div
        ref={ref}
        className={cn(
          'relative flex w-full gap-4 px-6 pt-6',
          {
            'pb-[50px]': isOnPDP,
            'pb-6': !isOnPDP,
            'px-6 pb-4 pt-6': isOnPDP && showSavingsCalculatorV2,
          },
          className
        )}
        {...props}
      >
        {!showSavings && (
          <div className="ml-[-4px] mt-[-4px] flex h-10 w-10 shrink-0 items-center justify-center gap-0 rounded-full border border-solid border-flexcar-neutral80 bg-flexcar-neutral100 p-[10px]">
            <SavingsBadgeIcon size={{ width: 20, height: 20 }} />
          </div>
        )}

        <div className="flex w-full flex-col">
          {showSavings && !showSavingsCalculatorV2 ? (
            <>
              <p className="body2-strong z-1 text-flexcar-neutral10">
                Your estimated savings
              </p>
              <Spacer variant="height8" />
            </>
          ) : null}

          {!showSavings && (
            <>
              <p className="body2-strong text-[12px] uppercase tracking-[0.48px] text-flexcar-neutral60">
                Estimated savings
              </p>
              <Spacer variant="height12" />
            </>
          )}

          <div className="z-1 inline w-full">{children}</div>
        </div>
      </div>
    );
  }
);

SalesPitchTextContainer.displayName = 'SalesPitchTextContainer';

export default SalesPitchTextContainer;
